module.exports = "https://web-assets.ifttt.com/packs/media/new_home/google_play-09e6f8b7.svg";